import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Grid } from "@material-ui/core";
import { DPExportButton } from "Components/DP";
import { successToast, errorToast } from "Modules/DPToast";
import mutations from "Shared/mutations";
import { useCashBalanceReportHook } from "../useCashBalanceReportHook";
import { PayPeriodEndDateSelect } from "../../PayPeriodEndDateSelect/PayPeriodEndDateSelect";
import { ExportCashBalanceReportMutation, ExportCashBalanceReportMutationVariables } from "generated/graphql";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import {
  ComplianceReportLabel,
  ComplianceReportPath,
} from "../../ComplianceReports";

export const CashBalanceReportActions = () => {
  const [exportReportFn] = useMutation<ExportCashBalanceReportMutation, ExportCashBalanceReportMutationVariables>(
    mutations.EXPORT_CASH_BALANCE_REPORT
  );
  const { date, onChangeDate } = useCashBalanceReportHook();
  const [disableExportButton, setDisableExportButton] = useState(date === "");

  const handleExportButtonClick = async () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ReportExportClicked,
      payload: { tab: ComplianceReportLabel[ComplianceReportPath.cashBalance] },
    });

    setDisableExportButton(true);
    try {
      const exportResponse = await exportReportFn({
        variables: {
          payPeriodEndsAtDate: date
        }
      });
      successToast(exportResponse.data!.exportCashBalanceReport.message);
    } catch (e) {
      setDisableExportButton(true);
      errorToast("Failed to export report.");
    }
  };

  const handleDateChange = (newDate: string) => {
    // Disable export if 'All' is selected
    if (newDate === "") {
      onChangeDate(newDate);
      setDisableExportButton(true);
    } else if (newDate !== date) {
      onChangeDate(newDate);
      setDisableExportButton(false);
    }
  };

  return (
    <Grid item xs={12} container justify="space-between" alignItems="center">
      <PayPeriodEndDateSelect date={date} onChangeDate={handleDateChange} />
      <DPExportButton
        handleExport={handleExportButtonClick}
        disabled={disableExportButton}
        align="right"
        size="large"
      />
    </Grid>
  );
};
